module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/95/assets/images/c36aff78e159151c8c7e7ae306064e0e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Bronze/Bronze5.svg
// module id = on1x
// module chunks = 1